








































  import Vue from 'vue';

  export default Vue.extend({
    name: 'Tooltip',
    props: {
      icone: {
        type: String,
        default: 'information',
      },
      valeurMargeLeft: {
        type: String,
        default: '0',
      },
      messages: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        open: false,
      };
    },
    computed: {
      nomIcone(): string {
        return `mdi-${this.icone}`;
      },
    },
    methods: {
      close(): void {
        this.open = false;
      },
    },
  });
